// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__20b41","boxTitle":"Qualiphy_boxTitle__70RrQ","box":"Qualiphy_box__1-N6Z","toggleWrap":"Qualiphy_toggleWrap__1coEx"};